import { render, staticRenderFns } from "./UserOfNetsisKasaAssign.vue?vue&type=template&id=6e4bb3ce&"
import script from "./UserOfNetsisKasaAssign.vue?vue&type=script&lang=js&"
export * from "./UserOfNetsisKasaAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports